// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"557":"81560289","929":"81560289","960":"81560289"}[chunkId] + ".chunk.css";
};